import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  checkingStatus: boolean
  onStatusCheck: () => void
  pendingState: boolean
  isLeaveIncidence?: boolean
}

const Pending = ({
  checkingStatus,
  onStatusCheck,
  pendingState,
  isLeaveIncidence = false,
}: Props) => {
  const resolveTitle = () => {
    if (pendingState) {
      return i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.waiting_title')
    } else {
      return i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.title')
    }
  }
  return (
    <>
      <Box gap="s4" flexDirection="row">
        <Icon.Medium icon="spinner" color="viridian1000" />
        <Text.Header2>{resolveTitle()}</Text.Header2>
      </Box>
      <>
        {isLeaveIncidence
          ? i18n.t('payroll_integrations.incidences.datev_lauds.absences.pending.message')
          : i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.message')}
      </>
      <Button onClick={onStatusCheck} disabled={checkingStatus}>
        {i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.status_check')}
      </Button>
    </>
  )
}

export default Pending
